import React from 'react';
import { companyLiquidationSteps } from '../data/sharedSteps';
import { PAGE_META } from '../data/pageMetaConfig';
import SimpleContactButton from '../components/SimpleCBT';

const path = '/company-liquidation';

export const pageMeta = {
  title: PAGE_META[path].title,
  metaDescription: PAGE_META[path].description,
  path,
  h1: 'פירוק חברה מרצון',
  faqSubtitle: 'מצאו תשובות לשאלות נפוצות בנוגע לפירוק חברה מרצון וסגירת חברה ברשם החברות.',
};

export const steps = companyLiquidationSteps;

export const faq = [
  {
    question: 'מה ההבדל בין פירוק מרצון רגיל לפירוק מזורז?',
    answer:
      'פירוק מזורז מתאים במקרים מסוימים לחברה שאין לה נכסים, חובות או הליכים פתוחים. פירוק רגיל מתאים למצבים שבהם נדרש הליך רחב יותר, לרבות מינוי מפרק והשלמת פעולות נוספות.',
  },
  {
    question: 'האם חברה לא פעילה ממשיכה לצבור חובות?',
    answer:
      'במקרים רבים חברה רשומה שלא פורקה ממשיכה להיות קיימת ועלולה להמשיך לצבור חובות אגרה או לקבל התראות מרשם החברות. לכן כדאי לבדוק סגירה מסודרת.',
  },
  {
    question: 'האם אפשר לפרק חברה שיש לה חובות?',
    answer:
      'במקרים מסוימים כן, אבל צריך לבדוק קודם את מצב החובות, סוג הנושים והיכולת של החברה להסדיר את ההתחייבויות שלה. אם החברה לא יכולה לשלם את חובותיה, ייתכן שיידרש מסלול אחר ולא פירוק מרצון רגיל.',
  },
  {
    question: 'כמה זמן לוקח לפרק חברה?',
    answer:
      'משך ההליך משתנה לפי מסלול הפירוק, מצב החברה, החובות, המסמכים והטיפול מול רשם החברות. חברה פשוטה וללא חובות יכולה להסתיים מהר יותר מחברה עם נושאים פתוחים.',
  },
];

export const sections = [
  {
    title: 'רוצים לסגור חברה? חשוב לעשות את זה נכון',
    content: (
      <>
        <p>
          אם יש לכם חברה שכבר לא פעילה, חברה שלא מייצרת הכנסות, או חברה שאתם רוצים לסגור בצורה
          מסודרת – חשוב לדעת שלא מספיק &quot;להפסיק להשתמש בה&quot;. חברה רשומה ממשיכה להתקיים
          כל עוד היא לא פורקה או חוסלה כדין. במקרים רבים, גם חברה לא פעילה יכולה להמשיך לצבור
          חובות אגרה, לקבל התראות, ולהישאר רשומה ברשם החברות.
        </p>
        <p>
          הליך פירוק חברה מרצון נועד לאפשר לבעלי מניות לסגור חברה בצורה מסודרת, כאשר החברה
          יכולה לעמוד בהתחייבויות שלה, להסדיר את חובותיה ולסיים את פעילותה מול רשם החברות.
          במשרד מיכלסון ושות׳ אנחנו מלווים בעלי מניות ודירקטורים בהליכי פירוק חברה מרצון, הכנת
          מסמכים, בדיקת מצב החברה, התנהלות מול רשם החברות, מינוי מפרק וניהול ההליך עד לסגירת
          החברה במקרים המתאימים.
        </p>
        <p>
          המטרה שלנו היא פשוטה: לבדוק את מצב החברה, להבין איזה מסלול פירוק מתאים לה, וללוות
          אתכם בצורה מסודרת עד לסגירת החברה.
        </p>
      </>
    ),
  },
  {
    title: 'מהו פירוק חברה מרצון?',
    content: (
      <>
        <p>
          פירוק חברה מרצון הוא הליך שבו בעלי המניות של החברה מחליטים לסיים את פעילות החברה
          ולפרק אותה בצורה מסודרת. במילים פשוטות: אם החברה כבר לא פעילה, אין בה צורך, או
          שבעלי המניות רוצים לסגור אותה – לא מספיק להשאיר אותה &quot;רדומה&quot;. צריך לבצע
          הליך מסודר מול רשם החברות.
        </p>
        <p>
          פירוק מרצון מתאים בדרך כלל לחברה שיכולה לפרוע את החובות שלה, להסדיר את ההתחייבויות
          שלה ולסיים את פעילותה בצורה תקינה. לפי רשות התאגידים, קיימים מסלולים שונים לפירוק
          חברה פרטית, ובין היתר פירוק מרצון בהליך מזורז לחברות שעומדות בתנאים מסוימים, למשל
          ללא נכסים, ללא חובות וללא הליכים משפטיים תלויים.
        </p>
      </>
    ),
  },
  {
    title: 'מהו פירוק חברה מרצון בהליך מזורז?',
    content: (
      <>
        <p>
          פירוק מרצון בהליך מזורז הוא מסלול פשוט יותר, שיכול להתאים לחברות שעומדות בתנאים
          מסוימים. בדרך כלל מדובר בחברה לא פעילה, ללא נכסים, ללא חובות וללא הליכים משפטיים
          פתוחים. לפי רשות התאגידים, פירוק מרצון בהליך מזורז מיועד לחברות שאין להן נכסים,
          חובות, הליכים משפטיים תלויים או הליכי אכיפה מנהליים תלויים.
        </p>
        <p>
          אבל חשוב לדעת: לא כל חברה לא פעילה מתאימה להליך מזורז. צריך לבדוק את מצב החברה
          בפועל, האם קיימים חובות אגרה, האם היו פעולות לאחרונה, האם יש נכסים או התחייבויות,
          ומה הדרישות של רשם החברות.
        </p>
      </>
    ),
  },
  {
    title: 'מתי כדאי לפנות לעורך דין לפירוק חברה?',
    content: (
      <>
        <p>
          כדאי לפנות לייעוץ כאשר רוצים לסגור חברה בצורה מסודרת, ולא להשאיר אותה פתוחה ללא
          טיפול. כדאי לבדוק הליך פירוק חברה מרצון אם אתם מזהים אחד או יותר מהמצבים הבאים:
        </p>
        <ul>
          <li>החברה כבר לא פעילה.</li>
          <li>החברה לא מייצרת הכנסות.</li>
          <li>אין צורך עסקי להמשיך להחזיק את החברה.</li>
          <li>החברה צוברת חובות אגרה לרשם החברות.</li>
          <li>בעלי המניות רוצים לסיים את פעילות החברה.</li>
          <li>יש צורך להסדיר נכסים, חובות או התחייבויות לפני סגירה.</li>
          <li>אתם לא בטוחים אם מתאים הליך פירוק מרצון רגיל או מזורז.</li>
          <li>החברה עדיין רשומה, למרות שבפועל היא כבר לא פועלת.</li>
        </ul>
        <p>
          בשלב הזה חשוב לא להשאיר את החברה פתוחה &quot;על הנייר&quot;. חברה שלא נסגרת בצורה
          מסודרת יכולה להמשיך ליצור בעיות, התראות וחובות מיותרים.
        </p>
        <div className="not-prose">
          <SimpleContactButton className="mt-8 !mb-8" />
        </div>
      </>
    ),
  },
  {
    title: 'איך עורך דין לפירוק חברה יכול לעזור?',
    content: (
      <>
        <p>
          עורך דין לפירוק חברה לא רק מגיש מסמכים. התפקיד שלו הוא לבדוק את מצב החברה, להבין
          אם היא עומדת בתנאים, לבחור את המסלול המתאים ולהכין את ההליך בצורה נכונה. במשרדנו
          הליווי כולל בין היתר:
        </p>
        <h3>בדיקת מצב החברה</h3>
        <p>
          בשלב הראשון אנחנו בודקים האם החברה פעילה, האם קיימים חובות, נכסים, חשבונות בנק,
          התחייבויות, הליכים משפטיים או נושאים פתוחים מול רשם החברות. המטרה היא להבין האם
          החברה מתאימה לפירוק מרצון, ואם כן – באיזה מסלול נכון לפעול.
        </p>
        <h3>בחירת מסלול פירוק מתאים</h3>
        <p>
          יש הבדל בין פירוק מרצון רגיל לבין פירוק מרצון בהליך מזורז. הליך מזורז יכול להתאים
          במקרים מסוימים לחברה שאין לה חובות, נכסים או הליכים תלויים. במקרים אחרים ייתכן
          שיידרש הליך פירוק מרצון רגיל, הכולל פעולות נוספות כמו מינוי מפרק, אסיפות והגשת
          מסמכים מסודרת. לא בוחרים מסלול רק לפי מה שנראה מהיר – בודקים מה באמת מתאים למצב
          החברה.
        </p>
        <h3>הכנת מסמכים והחלטות</h3>
        <p>
          הליך פירוק חברה דורש הכנה של מסמכים, החלטות בעלי מניות או דירקטורים, תצהירים,
          פרוטוקולים והגשות מול רשם החברות. מסמך לא נכון או חסר יכול לעכב את ההליך, ולכן
          חשוב להגיש את הדברים בצורה מסודרת.
        </p>
        <h3>מינוי מפרק וניהול ההליך</h3>
        <p>
          בפירוק מרצון רגיל, יש צורך במינוי מפרק שתפקידו לטפל בענייני החברה, להסדיר
          התחייבויות, לטפל בנכסים, ולנהל את ההליך עד לסיום. במשרדנו אנו מלווים את התהליך,
          מסבירים מה נדרש בכל שלב, ומוודאים שההליך מתקדם בצורה תקינה.
        </p>
        <h3>הסדרת חובות ונושאים פתוחים</h3>
        <p>
          לפני סגירת החברה, חשוב לבדוק אם יש חובות לרשם החברות, ספקים, רשויות, עובדים או
          גורמים אחרים. במקרים המתאימים, ניתן לבחון הסדרה של חובות או התחייבויות לפני
          השלמת הפירוק.
        </p>
        <h3>ליווי עד לסגירת החברה</h3>
        <p>
          המטרה היא לא רק להתחיל הליך פירוק, אלא להגיע לסיום מסודר של פעילות החברה ולמחיקתה
          במרשם, בהתאם למסלול המתאים ולהחלטות רשם החברות.
        </p>
      </>
    ),
  },
];
